import { IEdamaFood } from "model/food/types/edama.types"
import { IOpenFoodFactFood } from "model/food/types/openFoodFact.types"
import {
  isEdamaFood,
  isOpenFoodFactFood,
} from "model/food/utils/typeGuards/foodTypeGuards"
import OpenFoodFactScanResult from "./OpenFoodFactScanResult"
import EdamaScanResult from "./EdamaScanResult"

interface IProps {
  onBack: () => void
  food: IEdamaFood | IOpenFoodFactFood
  onSearch: () => void
}

const ScanResult = ({ food, onBack, onSearch }: IProps) => {
  if (isEdamaFood(food)) {
    return (
      <EdamaScanResult
        food={food}
        onBack={onBack}
        onSearch={onSearch}
        foodCreationMethod="BARCODE_SCAN"
      />
    )
  }

  if (isOpenFoodFactFood(food)) {
    return (
      <OpenFoodFactScanResult
        food={food}
        onBack={onBack}
        onSearch={onSearch}
        foodCreationMethod="BARCODE_SCAN"
      />
    )
  }

  return null
}

export default ScanResult
